
import React from "react";
import { Classname } from "@rivtn/noseur";
import styles from "../../assets/style.module.css";

export function useScroller() {
    const ref = React.useRef<HTMLDivElement>(null);
    const scroll = (direction: 1 | -1) => {
        const el = ref.current;
        if (!el) return;
        el.scrollBy({ left: direction * el.clientWidth * 0.8, behavior: "smooth" });
    };
    return { ref, prev: () => scroll(-1), next: () => scroll(1) };
}

export function ScrollButtons({ onPrev, onNext }: { onPrev: () => void; onNext: () => void; }) {
    return (<div className={styles["scroll-btns"]}>
        <button className={styles["scroll-btn"]} onClick={onPrev} aria-label="Previous"><i className="fa fa-arrow-left" /></button>
        <button className={styles["scroll-btn"]} onClick={onNext} aria-label="Next"><i className="fa fa-arrow-right" /></button>
    </div>);
}

export interface ScrollTrackProps {
    className?: string;
    children: React.ReactNode;
    trackRef: React.RefObject<HTMLDivElement | null>;
}

function ScrollTrack({ trackRef, className, children }: ScrollTrackProps) {
    return (<div ref={trackRef} className={Classname.build(styles["track"], className)}>{children}</div>);
}

export default ScrollTrack;
